export const TestsReportStore = {
    selectedDivisions: [],
    divisionWithChild: false,
    selectedCourse: 0,
    selectedEmployees: [],
    selectedEmployeeId: null,
    selectedUsers: [],
    selectedUserId: null,
};
